import { Text, Title, DetailText, Tag } from "../../components/units/Text"
// import { CommisionProps } from "../../components/Rest/Commission"
import { useSignedInContext } from "../../context/AuthContextProvider";
import { useState, useEffect } from "react";
import { data, useParams } from 'react-router-dom';
import { BoxWrapper } from "../../components/Wrappers/Wrappers";
import { LgFormInput, LgFormCkeckBox, LgSelect } from "../../components/Form/FormInput";
import { updateCommissionData } from "../../components/Rest/accumulator/components/updateCommissionData";
import { fetchCommissionData } from "../../components/Rest/accumulator/components/fetchCommissionData";
// import { CommisionProps } from "../../components/Rest/accumulator/interfaces/commission";
import { CommisionProps } from "../../interfaces/Commission/types";
import { RestApiState } from "../../interfaces/Rest/types";
import { LgSuggestionFormInput } from "../../components/Form/components/SuggestionInput"
import { fetchModelName } from '../../components/Rest/accumulator/components/fetchModelName'
import { fetchAccumulatorElements } from "../../components/Rest/accumulator/components/fetchAccumulatorElements"
import { fetchAccumulatorContactors } from "../../components/Rest/accumulator/components/fetchAccumulatorContactors"
import { fetchAccumulatorActivities } from "../../components/Rest/accumulator/components/fetchAccumulatorActivities";
import { 
    fetchAdditionalEquipment, 
    fetchChargeConnectors , 
    fetchCurrentSensors, 
    fetchDischargeConnectors, 
    fetchExternalRemoteControls,
    fetchBmsModel
} from "../../components/Rest/accumulator/components/fetchAccumulatorEntities";
 

const MAX_DOCUMENTATIONS = 5
const MAX_DOCUMENTATION_BYTES = 10 * 1024 * 1024
const DOCUMENTATION_TYPES = ['application/pdf']

interface UpdateCommissionProps {
    commission: {
        data: CommisionProps | null;
        changes: Set<keyof CommisionProps>;
        requestState: RestApiState;
        timeOutId: NodeJS.Timeout | null;
        filesToAdd: File[];
        idsToDelete: number[];
    }
}


const defaultUpdateCommissionState = { commission:{
    data: null,
    changes: new Set<keyof CommisionProps>(['is_cooling_activity', 'is_heating_activity', 'is_default_activity', 'is_waterproof_activity']),
    requestState: RestApiState.Idle,
    timeOutId: null,
    filesToAdd: [] as File[],
    idsToDelete: [] as number[],
}}

function documentationHref(url: string | null): string | undefined {
    if (!url) {
        return undefined
    }
    if (/^https?:\/\//i.test(url)) {
        return url
    }
    return `${process.env.REACT_APP_DJANGO_SERVER_URL}${url}`
}

function appendCommissionFields(form: FormData, fields: Partial<Record<keyof CommisionProps, unknown>>): void {
    Object.entries(fields).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            return
        }
        if (typeof value === 'boolean' || typeof value === 'number') {
            form.append(key, String(value))
            return
        }
        form.append(key, value as string | Blob)
    })
}

function CommissionDocumentationsField({
    documentations,
    filesToAdd,
    idsToDelete,
    remainingSlots,
    usedSlots,
    onFileChange,
    onQueueDelete,
    onRemovePending,
}: {
    documentations: CommisionProps['documentations']
    filesToAdd: File[]
    idsToDelete: number[]
    remainingSlots: number
    usedSlots: number
    onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onQueueDelete: (id: number) => void
    onRemovePending: (index: number) => void
}): JSX.Element {
    const visibleDocs = documentations.filter((doc) => !idsToDelete.includes(doc.id))
    const chooseDisabled = remainingSlots <= 0
    const isEmpty = visibleDocs.length === 0 && filesToAdd.length === 0

    return (
        <div className="flex flex-column narrow-gap relative flex-grow" style={{width: '100%'}}>
            <Text size="base">Документация</Text>
            <div className="cs-input cs-input-lg standart-border docs-file-input">
                <div className="docs-file-input__tags">
                    {isEmpty && (
                        <label htmlFor="documentations" className="docs-file-input__placeholder">
                            Добавьте файлы (PDF, до 10 МБ)
                        </label>
                    )}
                    {visibleDocs.map((doc) => {
                        const href = documentationHref(doc.url)
                        return (
                            <Tag key={doc.id} isBlock={false} className="docs-file-input__tag">
                                {href ? (
                                    <DetailText href={href} className="docs-file-input__tag-name">{doc.title}</DetailText>
                                ) : (
                                    <span className="docs-file-input__tag-name">{doc.title}</span>
                                )}
                                <button
                                    type="button"
                                    className="docs-file-input__remove"
                                    aria-label={`Удалить ${doc.title}`}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        onQueueDelete(doc.id)
                                    }}
                                >
                                    ×
                                </button>
                            </Tag>
                        )
                    })}
                    {filesToAdd.map((file, index) => (
                        <Tag key={`${file.name}-${index}`} isBlock={false} className="docs-file-input__tag">
                            <span className="docs-file-input__tag-name">{file.name}</span>
                            <button
                                type="button"
                                className="docs-file-input__remove"
                                aria-label={`Удалить ${file.name}`}
                                onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    onRemovePending(index)
                                }}
                            >
                                ×
                            </button>
                        </Tag>
                    ))}
                </div>
                <input
                    className="lg-file-input__native"
                    id="documentations"
                    name="documentations_upload"
                    type="file"
                    accept="application/pdf"
                    multiple
                    disabled={chooseDisabled}
                    onChange={onFileChange}
                />
                <label
                    htmlFor="documentations"
                    className={`lg-file-input__btn${chooseDisabled ? ' is-disabled' : ''}`}
                    aria-disabled={chooseDisabled}
                    onClick={(e) => {
                        if (chooseDisabled) {
                            e.preventDefault()
                        }
                    }}
                >
                    Выбрать файл
                </label>
            </div>
            <Text size="sm" color="secondary">
                {usedSlots} из {MAX_DOCUMENTATIONS}
            </Text>
        </div>
    )
}


function submitClassHandler(status: RestApiState): string {
    // Defines css class based on status
    if (status === RestApiState.Success) {
        return "submit-btn-success"
    }

    if (status !== RestApiState.Idle)  {
        return 'submit-btn disabled'
    }

    return "bg-secondary text-light"
}


export const UpdateCommission = () => {
    const { user } = useSignedInContext()
    const { serial_number } = useParams()

    const [commissionProps, setProps] = useState<UpdateCommissionProps>(defaultUpdateCommissionState)

    if (serial_number === undefined) {
        throw new Error("Serial number must be provided as parameter");
    }

    useEffect(() => {
        async function myFunction() {
            if (commissionProps.commission.requestState !== RestApiState.Idle) {
                updateRestApiStatus(RestApiState.Idle);
            }
        }

        if (commissionProps.commission.timeOutId !== null) {
            clearTimeout(commissionProps.commission.timeOutId)
        }

        if (commissionProps.commission.requestState !== RestApiState.Pending && commissionProps.commission.requestState !== RestApiState.Idle) {
            let timeOut = setTimeout(myFunction, 1500);
            setProps((prev) => ({
                ...prev,
                commission: {
                    ...prev.commission,
                    timeOutId: timeOut, // Update the requestState field
                },
            }));
        }

    }, [commissionProps.commission.requestState])

    const statusText = ():string => {
        let text = ''
        switch(commissionProps.commission.requestState) {
            case RestApiState.Idle : text = "" ; break;
            case RestApiState.Pending : text = "Обновляется"; break;
            case RestApiState.Success : text = "Обновлено"; break;
            case RestApiState.BadRequest : text = "Заполните поля"; break;
            case RestApiState.ServerError : text = "Ошибка сервера"; break;
            case RestApiState.Unknown : text = "Неизвестная ошибка"; break;
            default: text = "..."; break;
        }
        return text
    }

    const setCommissionData = (newData: typeof commissionProps.commission.data): void => {
        setProps(prev => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: newData,
            },
        }));
    }


    const updateDataValue = (e: React.ChangeEvent<HTMLInputElement>):void => {
        const { name, value } = e.target;
        const key = name as keyof CommisionProps;
        setProps((prev) => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: prev.commission.data
                ? { ...prev.commission.data, [key]: value }
                : null,
            },
        }));
        
        setProps((prevState) => {
            const updatedChanges = new Set(prevState.commission.changes); // Clone the current Set
            updatedChanges.add(key); // Add the new key
            return {
                ...prevState,
                commission: {
                    ...prevState.commission,
                    changes: updatedChanges, // Update changes with the new Set
              },
            };
        });
    };

    const documentationSlotCount = (state: UpdateCommissionProps['commission']): number => {
        const keptCount = (state.data?.documentations ?? []).filter(
            (doc) => !state.idsToDelete.includes(doc.id)
        ).length
        return keptCount + state.filesToAdd.length
    }

    const fileChangeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const selected = Array.from(e.target.files ?? [])
        e.target.value = ''

        if (selected.length === 0) {
            return
        }

        setProps((prev) => {
            const remainingSlots = MAX_DOCUMENTATIONS - documentationSlotCount(prev.commission)
            if (remainingSlots <= 0) {
                alert(`Можно прикрепить не более ${MAX_DOCUMENTATIONS} файлов`)
                return prev
            }

            const accepted: File[] = []
            for (const file of selected) {
                if (accepted.length >= remainingSlots) {
                    alert(`Можно прикрепить не более ${MAX_DOCUMENTATIONS} файлов`)
                    break
                }
                if (!DOCUMENTATION_TYPES.includes(file.type)) {
                    alert("Допустимые форматы PDF")
                    continue
                }
                if (file.size > MAX_DOCUMENTATION_BYTES) {
                    alert('Допустимый размер менее 10 МБ')
                    continue
                }
                accepted.push(file)
            }

            if (accepted.length === 0) {
                return prev
            }

            return {
                ...prev,
                commission: {
                    ...prev.commission,
                    filesToAdd: [...prev.commission.filesToAdd, ...accepted],
                },
            }
        })
    }

    const queueDocumentationDelete = (id: number): void => {
        setProps((prev) => {
            if (prev.commission.idsToDelete.includes(id)) {
                return prev
            }
            return {
                ...prev,
                commission: {
                    ...prev.commission,
                    idsToDelete: [...prev.commission.idsToDelete, id],
                },
            }
        })
    }

    const removePendingDocumentation = (index: number): void => {
        setProps((prev) => ({
            ...prev,
            commission: {
                ...prev.commission,
                filesToAdd: prev.commission.filesToAdd.filter((_, fileIndex) => fileIndex !== index),
            },
        }))
    }

    const updateBooleanDataValue = (e: React.ChangeEvent<HTMLInputElement>):void => {
        const { name, value } = e.target;
        const key = name as keyof CommisionProps;
        setProps((prev) => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: prev.commission.data
                ? { ...prev.commission.data, [key]: e.target.checked }
                : null,
            },
        }));
        
        setProps((prevState) => {
            const updatedChanges = new Set(prevState.commission.changes); // Clone the current Set
            updatedChanges.add(key); // Add the new key
            return {
                ...prevState,
                commission: {
                    ...prevState.commission,
                    changes: updatedChanges, // Update changes with the new Set
              },
            };
        });
    };

    const updateRestApiStatus = (status: RestApiState) => {
        setProps((prev) => ({
            ...prev,
            commission: {
                ...prev.commission,
                requestState: status, // Update the requestState field
            },
        }));
    }

    useEffect(() => {
        const fetchSectionData = async () => {
            
            const response = await fetchCommissionData(serial_number, user.role_slug)
            if (response) {
                setCommissionData(response)
            } 
        }
        fetchSectionData()
    }, [])

    const applyCommissionResponse = (response: CommisionProps): void => {
        setProps((prev) => ({
            ...prev,
            commission: {
                ...prev.commission,
                data: prev.commission.data
                    ? {
                        ...prev.commission.data,
                        ...response,
                        documentations: response.documentations ?? prev.commission.data.documentations ?? [],
                        chemistry_choices: response.chemistry_choices ?? prev.commission.data.chemistry_choices,
                        image_choices: response.image_choices ?? prev.commission.data.image_choices,
                    }
                    : response,
                filesToAdd: [],
                idsToDelete: [],
            },
        }))
    }

    const handelSubmit = (e: any) => {
        e.preventDefault();
        if (commissionProps.commission.data === null) {
            throw new Error("Commission cant be empty");
        }
        const dict: Partial<Record<keyof CommisionProps, any>> = {};
        commissionProps.commission.changes.forEach((key) => {
            if (key === 'documentations') {
                return
            }
            dict[key] = commissionProps.commission.data?.[key];
        });

        const filesToAdd = commissionProps.commission.filesToAdd
        const idsToDelete = commissionProps.commission.idsToDelete

        if (filesToAdd.length === 0 && idsToDelete.length === 0) {
            updateCommissionData(serial_number, user.role_slug, dict as Record<string, unknown>, updateRestApiStatus, applyCommissionResponse)
            return
        }

        const form = new FormData()
        appendCommissionFields(form, dict)
        filesToAdd.forEach((file) => form.append("documentations", file))
        idsToDelete.forEach((id) => form.append("documentations_delete", String(id)))

        updateCommissionData(serial_number, user.role_slug, form, updateRestApiStatus, applyCommissionResponse)
    }
    
    return (
        <div className='content-wrapper flex-grow acb-dashboard-wrapper show-up'>
            <DetailText href={`/react/acb/detail/${serial_number}`}>
                    Назад
            </DetailText>
            <br />
            <br />
            <Title className="dispaly-block">{serial_number}</Title>
            <br />
            <BoxWrapper bg="bg-primary" p="p3" r="r15">
                <Text size="lg" className="bold dispaly-block">Форма ввода в эксплуатацию</Text>
                <br />
                {commissionProps.commission.data ? (
                    <form onSubmit={handelSubmit} className="organization-form">
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Изображение</Text>
                            <Text size="base" className="dispaly-block">Выберите изображение</Text>
                            <div className="flex flex-wrap">
                                
                                {commissionProps.commission.data.image_choices.map((option) => (
                                    <div className="img-box r5 overflow-hidden cursor-pointer"
                                        style={{
                                            width: '125px',
                                            height: '125px',
                                            border: option.value === commissionProps.commission.data?.image ? '1px solid #FF7D7A' : ''
                                        }}
                                        onClick={(e:any) => {
                                            const newImage = option.value as number
                                            setProps((prev) => ({
                                                ...prev,
                                                commission: {
                                                  ...prev.commission,
                                                  data: prev.commission.data
                                                    ? { ...prev.commission.data, image: newImage }
                                                    : null,
                                                },
                                            }));
                                            
                                            setProps((prevState) => {
                                                const updatedChanges = new Set(prevState.commission.changes); // Clone the current Set
                                                updatedChanges.add('image'); // Add the new key
                                                return {
                                                    ...prevState,
                                                    commission: {
                                                        ...prevState.commission,
                                                        changes: updatedChanges, // Update changes with the new Set
                                                  },
                                                };
                                            });
                                        }}
                                    >
                                        <img 
                                            src={`${process.env.REACT_APP_DJANGO_SERVER_URL}${option.label}`} 
                                            alt="" 
                                            style={{
                                               objectFit: "contain"
                                            }}    
                                        />
                                    </div>
                                ))}
                            </div>
                            <div style={{display: 'none'}}>
                            
                            <LgSelect 
                                    value={commissionProps.commission.data.image} 
                                    label='Изображение' 
                                    name='image' 
                                    valueSetter={updateDataValue} 
                                    options={[
                                        {value: '', label: "Не выбрано"},
                                        ...commissionProps.commission.data.image_choices.map(item => ({
                                        value: item.value,
                                        label: item.label ? item.label : '',
                                    }))]}
                                />
                            </div>
                            
                        </div>
                        <br /><br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Бизнес свойства</Text>
                            <LgFormInput 
                                value={commissionProps.commission.data.order_number} 
                                label='Номер заказа' 
                                name='order_number' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Основные свойства</Text>
                            <LgFormInput 
                                value={commissionProps.commission.data.voltage} 
                                label='Наряжение Кв.' 
                                name='voltage' 
                                type='number' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.nominal_capacity} 
                                label='Номинальная емкость (Ач)' 
                                name='nominal_capacity' 
                                type='number' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.weight} 
                                label='Вес (Кг)' 
                                name='weight' 
                                type='number' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.size} 
                                label='Габаритные размеры' 
                                name='size' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.cycle_capacity} 
                                label='Срок службы (циклы)' 
                                name='cycle_capacity' 
                                type='number' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Исполнение</Text>
                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_activity} 
                                label='Исполнение' 
                                name='accumulator_activity' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchAccumulatorActivities}
                            />
                            {/* <LgFormCkeckBox 
                                value={commissionProps.commission.data.is_cooling_activity} 
                                label='Исполнение охлаждение' 
                                name='is_cooling_activity' 
                                required={false} 
                                valueSetter={updateBooleanDataValue} 
                            />
                            <LgFormCkeckBox 
                                value={commissionProps.commission.data.is_heating_activity} 
                                label='Исполнение отопление' 
                                name='is_heating_activity'  
                                required={false} 
                                valueSetter={updateBooleanDataValue} 
                            />
                            <LgFormCkeckBox 
                                value={commissionProps.commission.data.is_default_activity} 
                                label='Исполнение по умолчанию' 
                                name='is_default_activity'
                                required={false} 
                                valueSetter={updateBooleanDataValue} 
                            />
                            <LgFormCkeckBox 
                                value={commissionProps.commission.data.is_waterproof_activity} 
                                label='Исполнение водоустойчевость' 
                                name='is_waterproof_activity' 
                                required={false} 
                                valueSetter={updateBooleanDataValue} 
                            /> */}
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Прочее</Text>
                            <LgFormInput 
                                value={commissionProps.commission.data.sku} 
                                label='Артикул' 
                                name='sku' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgSelect 
                                value={commissionProps.commission.data.chemistry} 
                                label='Тип химии' 
                                name='chemistry' 
                                valueSetter={updateDataValue} 
                                options={commissionProps.commission.data.chemistry_choices} 
                            />
                           

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_element} 
                                label='Тип элементов' 
                                name='accumulator_element' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchAccumulatorElements}
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.batch_code} 
                                label='Код партии элементов' 
                                name='batch_code' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_model_name} 
                                label='Серия АКБ' 
                                name='accumulator_model_name' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchModelName}
                            />
                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_contactor} 
                                label='Тип контакторов' 
                                name='accumulator_contactor' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchAccumulatorContactors}
                            />
                            {/* <LgFormInput 
                                value={commissionProps.commission.data.bms_model} 
                                label='Модель BMS' 
                                name='bms_model' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            /> */}
                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_bms_model} 
                                label='Модель BMS' 
                                name='accumulator_bms_model' 
                                type='text' 
                                required={false}
                                valueSetter={updateDataValue} 
                                fetchSuggestion={fetchBmsModel}
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.bms_hw_version} 
                                label='Версия HW BMS' 
                                name='bms_hw_version' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.bms_fw_version} 
                                label='Версия FW BMS' 
                                name='bms_fw_version' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_additional_equipment}
                                label='Доп. оборудование'
                                name='accumulator_additional_equipment'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchAdditionalEquipment}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_discharge_connector}
                                label='Разъем разряда'
                                name='accumulator_discharge_connector'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchDischargeConnectors}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_charge_connector}
                                label='Разъем заряда'
                                name='accumulator_charge_connector'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchChargeConnectors}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_current_sensor}
                                label='Датчик тока'
                                name='accumulator_current_sensor'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchCurrentSensors}
                            />

                            <LgSuggestionFormInput
                                value={commissionProps.commission.data.accumulator_external_remote_control}
                                label='Внешний пульт'
                                name='accumulator_external_remote_control'
                                type='text'
                                required={false}
                                valueSetter={updateDataValue}
                                fetchSuggestion={fetchExternalRemoteControls}
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.accumulator_external_remote_control_hw_version} 
                                label='Версия HW Внешнего пульта' 
                                name='accumulator_external_remote_control_hw_version' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.accumulator_external_remote_control_fw_version} 
                                label='Версия FW Внешнего пульта' 
                                name='accumulator_external_remote_control_fw_version' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Администрация</Text>
                            <LgFormInput 
                                value={commissionProps.commission.data.comment} 
                                label='Комментарий' 
                                name='comment' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <CommissionDocumentationsField
                                documentations={commissionProps.commission.data.documentations ?? []}
                                filesToAdd={commissionProps.commission.filesToAdd}
                                idsToDelete={commissionProps.commission.idsToDelete}
                                remainingSlots={MAX_DOCUMENTATIONS - documentationSlotCount(commissionProps.commission)}
                                usedSlots={documentationSlotCount(commissionProps.commission)}
                                onFileChange={fileChangeHandler}
                                onQueueDelete={queueDocumentationDelete}
                                onRemovePending={removePendingDocumentation}
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <button 
                                type="submit"
                                disabled={ commissionProps.commission.requestState !== RestApiState.Idle }
                                className={`${submitClassHandler(commissionProps.commission.requestState)} p2 bold` }
                                style={{position:'relative', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                                >
                                { commissionProps.commission.requestState === RestApiState.Idle && <Text  className="slide-bottom-to-top">Сохранить</Text>  }
                                { commissionProps.commission.requestState === RestApiState.Pending && <Text className="slide-bottom-to-top">{ <div className="btnloader"></div> }</Text>}
                                { (commissionProps.commission.requestState !== RestApiState.Pending && commissionProps.commission.requestState !== RestApiState.Idle) && <Text className="slide-bottom-to-top">{ statusText() }</Text>} 
                            </button>
                            <DetailText bg="bg-danger" p="p2" r="r10" color="light" className="bold text-center r5" href={`/react/acb/${serial_number}/review-commission`} style={{width: '100%', height: '36px !important'}}>Страница ввода в эксплуатацию</DetailText>
                        </div>

                        
                        
                    </form>
                ) : (
                    <h1>Loading...</h1>
                )}
            </BoxWrapper>

        </div>
    )
}


export const UpdateCommissionComment = () => {
    return (
        <div className='content-wrapper flex-grow acb-dashboard-wrapper show-up'>
            <h1>Hello world</h1>
        </div>
    )
}